import io from 'socket.io-client';

const loggers = [
  (meta, data) => {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line
      console.log(data);
    }
  },
];

const meta = {
  platform: {
    osType: 'WebApp',
    channel: 'web',
    tag: process.env.TAG_COMMIT,
    osVersion: process.env.TAG_COMMIT,
    hash: process.env.HASH_COMMIT,
    userAgent: navigator.userAgent,
  },
  user: {},
};

const room = {
  id: undefined,
};
const appStarted = new Date();

export const updateUserInfo = user => {
  meta.user = { ...meta.user, ...user };
};

export const updateRoomId = id => {
  room.id = id;
};

export const init = () =>
  new Promise(resolve => {
    const socket = io('https://chabarak-production.ava.me/', {
      transports: ['websocket'],
    });
    socket.on('connect', () => {
      loggers.push((m, data) => socket.emit('log', JSON.stringify({ meta: m, data })));
      resolve('Chabarak logger initialized');
    });
  });

export const log = (tag, level, content) => {
  loggers.map(f => f(meta, { tag, level, timestamp: Date.now(), content, roomId: room.id }));
};

window.addEventListener('unhandledrejection', event => {
  log('unhandledRejection', 'error', { ...event });
});

window.onerror = (msg, url, line, column, err) => {
  log('windowOnError', 'error', { msg, url, line, column, err: JSON.stringify(err) });
};

if (window.electronIPC) {
  window.electronIPC.onLog((event, msg) => {
    const { tag, level, content } = msg;
    log(tag, level, content);
  });
}

let uptimeLogInterval;
if (!uptimeLogInterval) {
  uptimeLogInterval = setInterval(() => {
    log('uptime', 'info', {
      uptimeMs: new Date() - appStarted,
    });
  }, 10000);
}
